// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:4000',
    firebase: {
      apiKey: "AIzaSyBKG0Q5VKwxL1j3iTi3hJsQTSvB3bl_BOc",
      authDomain: "united-inventory-app.firebaseapp.com",
      projectId: "united-inventory-app",
      storageBucket: "united-inventory-app.appspot.com",
      messagingSenderId: "98510618442",
      appId: "1:98510618442:web:d1125c173d2b42d728cbb3",
      measurementId: "G-PVVVZFTEPR"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
